import React, { createContext, useState } from 'react'
export type IndicatorContextType = {
  mainIndicatorDisplayed: boolean
  setMainIndicatorDisplayed: (arg0: boolean) => void
}
export const IndicatorContext: React.Context<IndicatorContextType> =
  createContext<IndicatorContextType>({
    mainIndicatorDisplayed: false,
    setMainIndicatorDisplayed: () => {},
  })
export const IndicatorContextProvider = ({
  children,
}: {
  children: React.ReactNode
}): React.ReactNode => {
  const [mainIndicatorDisplayed, setMainIndicatorDisplayed] =
    useState<boolean>(false)
  return (
    <IndicatorContext.Provider
      value={{
        mainIndicatorDisplayed,
        setMainIndicatorDisplayed,
      }}
    >
      {children}
    </IndicatorContext.Provider>
  )
}
